import React from 'react';
import { Dropdown, IDropdownStyles } from '@fluentui/react';
import { KustoTenant } from '../../api/KustoAccessApi';

interface IKustoTenantDropdownProps {
    tenants: KustoTenant[];
    selectedTenantId: string;
    onChange: (tenantId: string) => void;
    disabled?: boolean;
    required?: boolean;
    errorMessage?: string;
}

const optionStyle = {
    height: 'auto',
    minHeight: 36,
    paddingTop: 8,
    paddingBottom: 8,
};

const styles: Partial<IDropdownStyles> = {
    title: {
        height: 'auto',
        minHeight: 32,
        paddingTop: 6,
        paddingBottom: 6,
        lineHeight: '20px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
    dropdownItem: optionStyle,
    dropdownItemSelected: optionStyle,
    dropdownItemDisabled: optionStyle,
    dropdownItemSelectedAndDisabled: optionStyle,
    dropdownOptionText: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
};

export const KustoTenantDropdown: React.FC<IKustoTenantDropdownProps> = ({
    tenants,
    selectedTenantId,
    onChange,
    disabled,
    required,
    errorMessage,
}) => (
    <Dropdown
        label="Tenant"
        placeholder="Select a supported tenant"
        options={tenants.map((tenant) => ({
            key: tenant.tenantId,
            text: `${tenant.displayName} (${tenant.tenantId})`,
        }))}
        selectedKey={selectedTenantId || null}
        onChange={(_, option) => onChange(String(option?.key ?? ''))}
        disabled={disabled}
        required={required}
        errorMessage={errorMessage}
        styles={styles}
    />
);
